<template>
    <div :class="{ show, hide }" class="overlay"></div>
</template>

<script>
export default {
    props: {
        show: {
            required: true,
            type: Boolean
        }
    },
    computed: {
        hide() {
            return !this.show;
        }
    }
}
</script>
